import React, { useMemo, useRef } from "react";
import throttle from "lodash/throttle";
import HighlightableItemBox from "./HighlightableItemBox";
import { useDispatch, useSelector } from "react-redux";
import { getItemExecutionPropById } from "student-front-commons/src/selectors/itemExecution";
import { readLongText } from "student-front-commons/src/actions/itemExecution";

const TextExerciseRender = (props) => {
  const text = useSelector(getItemExecutionPropById(props.itemId, "item.text"));
  const dispatch = useDispatch();

  const readLongTextRef = useRef(
    throttle(() => {
      dispatch(readLongText());
    }, 30000)
  );

  const handleMouseMove = () => readLongTextRef.current();

  const textWithStyles = useMemo(() => {
    return text
      .replaceAll('""', "")
      .replaceAll(
        "<title>",
        '<h4 style="font-weight: bold !important; font-size: 22px !important; margin: 0 !important;">'
      )
      .replaceAll("</title>", "</h4>")
      .replaceAll("<b>", '<b style="font-weight: bold !important;">')
      .replaceAll("<subtitle>", '<subtitle style="font-weight: bold !important; font-size: 18px !important;">')
      .replaceAll("<link to", "<a target='_blank' style='text-decoration: underline; color: blue;' href")
      .replaceAll("</link>", "</a>")
      .replaceAll("\n", "</br>")
      .replaceAll("\n\n", "</br></br>");
  }, [text]);

  return (
    <div
      style={{
        maxWidth: 690,
        margin: "0 auto",
      }}
    >
      <HighlightableItemBox flexDirection="column">
        <div
          onMouseMove={handleMouseMove}
          dangerouslySetInnerHTML={{ __html: textWithStyles }}
          style={{ width: "100%", wordBreak: "break-word" }}
        />
      </HighlightableItemBox>
    </div>
  );
};

export default function TextExerciseItem() {
  const items = useSelector((state) => state.itemExecutions.allIds);

  return items.map((id) => <TextExerciseRender key={id} itemId={id} />);
}
